import axiosInstance from '../../../../config/axiosInstance';
const  AssetCategoryService = {
    async GetAllPartFinancial(redirectCallback) {
        try {            
            const ClientID=localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Setup/GetPartFinancial?ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            if(error.response.data.message=="Invalid token")
            {
                redirectCallback();
                return;
            }
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetAllPartFinancialByID(redirectCallback,ID) {
        try {            
            const ClientID=localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Setup/GetPartFinancialByID?ID=${ID}`);
        } catch (error) {
            if(error.response.data.message=="Invalid token")
            {
                redirectCallback();
                return;
            }
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async DeletePartFinancial(ID,redirectCallback) {
        try {
            const response = await axiosInstance.get(`/Setup/DeletePartFinancial?ID=${ID}`);
           return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    }
};

export default AssetCategoryService;